var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOffice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M21.25 21.25H2.75M20 21v-8.476a10 10 0 0 0-2.824-6.964l-1.011-1.042A5 5 0 0 0 12.577 3H11a1 1 0 0 0-1 1v17"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M7 10.5v1m6.5-2v1m0-4v1m3 2v1m-9.5 3v1m6.5-2v1m3-1v1m-9.5 3v1m6.5-2v1m3-1v1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M4 9v12M4 9l6-2"
})));
export default SvgIconOffice;